var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 34,
    viewBox: "0 0 58 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8555 15.5578C15.8555 15.5578 42.9568 15.8175 48.8244 14.1134C54.6921 12.4093 54.6846 3.56503 48.8244 1.38489C42.9643 -0.795248 40.9615 6.99754 40.9615 6.99754",
    stroke: "#90DDEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5801 24.8524C22.5801 24.8524 42.4694 23.0554 51.2376 24.8524C60.0058 26.6494 57.2138 31.8046 53.0583 32.0402C48.9028 32.2759 45.0682 29.5454 45.0682 29.5454",
    stroke: "#90DDEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04297 25.8281H12.9506",
    stroke: "#90DDEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05859 4.47715C1.05859 4.47715 7.09193 4.97731 14.241 4.97731C21.3902 4.97731 31.0804 4.03906 31.0804 4.03906",
    stroke: "#90DDEC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon);
export default __webpack_public_path__ + "static/media/FlowIcon.63b2d199f3bd8e918aa6de3c347452d7.svg";
export { ForwardRef as ReactComponent };